import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import QRCode from 'qrcode.react';
import { message } from 'antd';
import styles from './ScanView.module.scss';
import LabelButton from '../LabelButton';
import { Codes } from '../../enum';
import Loading from '../Loading';

type Props = {
  url: string;
  resultUrl: string;
  params: any;
  onSuccess: (result: any) => void;
  onFail: (result: any) => void;
  onBack: () => void;
}

const ScanView: React.FC<Props> = ({
  url, resultUrl, params, onSuccess, onFail, onBack,
}) => {
  const { t } = useTranslation();
  const [qrValue, setQrValue] = useState<string>('');
  let timer: NodeJS.Timeout | null = null;

  const startFetchResult = (id: string) => {
    timer = setTimeout(() => {
      axios({
        method: 'get',
        baseURL: process.env.REACT_APP_SCAN_URL,
        url: `${resultUrl}/${id}`,
      }).then(({ data }) => {
        if (data.error !== Codes.Success) {
          message.error(data.desc); // todo locales
          return;
        }
        const { state } = data.result;
        if (state === 1) {
          onSuccess(data.result);
        } else if (state === 0) {
          onFail(data.result);
        } else {
          startFetchResult(id);
        }
      });
    }, 3000);
  };

  const getQr = () => {
    axios({
      method: 'post',
      baseURL: process.env.REACT_APP_SCAN_URL,
      url,
      data: params,
    }).then(({ data }) => {
      if (data.error !== Codes.Success) {
        message.error(data.desc); // todo locales
        return;
      }
      setQrValue(JSON.stringify(data.result.qrCode));
      startFetchResult(data.result.id);
      // startFetchResult('375bcef0-6351-45aa-93bc-b658d7a820ee'); // todo temp
    }).catch((e) => {
      message.error(e.message);
    });
  };

  useEffect(() => {
    getQr();
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {
          qrValue
            ? (
              <div className={styles.qr}>
                <QRCode value={qrValue} size={144} />
              </div>
            )
            : <Loading />
        }
      </div>
      <div className={styles.tip}>{ t('use_onto_scan') }</div>
      <LabelButton label={t('back')} type="normal" onClick={onBack} />
    </div>
  );
};

export default ScanView;
